import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
// @ts-ignore TS5097
import { MenuManagementJobTargetStatus } from '@/pages/menu-managements/executions/service.ts';
import { MenuManagementExecutionService } from '@/services/Execution/MenuManagementExecutionService';

export type MenuManagementJobTarget = {
  id: string;
  master_store_name: string;
  status: MenuManagementJobTargetStatus;
};

export type ShowExecutionResponse = {
  id: string;
  is_executed: boolean;
  scheduled_date: string | null; // 202312241010
  created_at: string;
  menu_management_job_targets: MenuManagementJobTarget[];
};

export const useMenuManagementExecutionShow = async (
  id: string
): Promise<ShowExecutionResponse> => {
  const menuManagementExecutionService = new MenuManagementExecutionService(
    getClient()
  );
  try {
    const res = await menuManagementExecutionService.show(id);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
